import React, { useEffect, useMemo, useState } from 'react';
import FormPage from '../../../../shared/Layout/FormPage';
import CustomCard, { CustomGridLayout } from '../../../../shared/Cards/CustomCard';
import { CustomDropDown, CustomInput, CustomTextArea } from '../../../../shared/Input/AllInputs';
import formValidation from '../../../../utils/validations';
import PrimaryButton, { CustomButton } from '../../../../shared/Button/CustomButton';
import { yesNoOptions } from '../../../../utils/dropdownConstants';
import RuleForm from './RulesForm/RuleForm';
import { addReport, editReport, getGeneratedReport, getReport } from '../../../../redux/actions/More/ReportAction';
import { useHistory, useParams } from 'react-router-dom';
import { showFormErrors, snakeToCapitalized } from '../../../../utils/commonFunctions';
import { useDispatch } from 'react-redux';
import CustomPickList from '../../../../shared/Input/CustomPickList';
import PurchasedServices from './RulesForm/PurchasedServices';

import {
    agreementDataPoints,
    commissionsDataPoints,
    employeeEventsDataPoints,
    employeeResourcesDataPoints,
    employeeTasksDataPoints,
    eventDataPoints,
    inventoryDataPoints,
    purchasedProductDataPoints,
    purchasedServiceDataPoints,
    resourcesDataPoints,
    rewardsDataPoints,
    tasksDataPoints,
    timesheetsDataPoints,
    userIndexDataPoints,
} from '../../../../utils/reportDataPoints';

export default function ReportForm() {
    const history = useHistory();
    const dispatch = useDispatch();

    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [reportLoading, setReportLoading] = useState(false);
    const [data, setData] = useState({
        title: '',
        description: '',
        rules: [
            // { ruleType: 'TIMESHEETS', userType: 'EMPLOYEE' },
            // { ruleType: 'TIMESHEETS', userType: 'EMPLOYEE' },
        ],
        totalColumns: [],
        sortColumns: [],
        formatType: 'PDF',
        showPageHeaders: false,
        showPageFooters: false,
        pageOrientation: 'LANDSCAPE',
    });
    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, data);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    useEffect(() => {
        if (id) {
            dispatch(
                getReport(id, (data) => {
                    setData({
                        title: data.title,
                        description: data.description,
                        rules: data.rules || [],
                        sortColumns: data.sortColumns || [],
                        formatType: data.formatType,
                        showPageHeaders: data.showPageHeaders,
                        showPageFooters: data.showPageFooters,
                        pageOrientation: data.pageOrientation,
                    });
                    setTimeout(() => {
                        setData((prev) => ({ ...prev, totalColumns: data.totalColumns || [] }));
                    }, 100);
                }),
            );
        }
    }, [id, dispatch]);

    const [addRuleDialog, setAddRuleDialog] = useState(false);
    const [selectedRule, setSelectedRule] = useState(null);

    const handleAddRule = () => {
        setAddRuleDialog(true);
        setSelectedRule(null);
    };

    const handleCancel = () => {
        setAddRuleDialog(false);
        setSelectedRule(null);
    };

    const handleSaveRule = (rule) => {
        if (selectedRule) {
            setData((prev) => ({
                ...prev,
                rules: prev.rules.map((r) => (r === selectedRule ? rule : r)),
            }));
        } else {
            setData((prev) => ({
                ...prev,
                rules: [...prev.rules, rule],
            }));
        }

        setAddRuleDialog(false);
        setSelectedRule(null);
    };

    const handleSave = () => {
        if (showFormErrors(data, setData)) {
            if (id) {
                dispatch(
                    editReport(id, data, setLoading, () => {
                        history.goBack();
                    }),
                );
            } else {
                dispatch(addReport(data, setLoading, history));
            }
        }
    };

    const [allDataPoints, setAllDataPoints] = useState([]);
    useEffect(() => {
        let datapoints = [];
        if (data?.rules) {
            data?.rules.forEach((rule, index) => {
                let ruleType = rule?.ruleType;
                let dataPoints = purchasedServiceDataPoints;
                let selectedDataPoints = rule[ruleType]['selectedDataPoints'];

                selectedDataPoints.forEach((dp) => {
                    datapoints.push(dataPoints.find((d) => d.value === dp));
                });
            });
        }
        setAllDataPoints(datapoints);
    }, [data?.rules]);

    const generateReport = () => {
        if (isModified) {
            dispatch(
                editReport(id, data, setLoading, () => {
                    dispatch(
                        getGeneratedReport(id, setReportLoading, (data) => {
                            console.log('generated report==>', data);

                            const base64 = data.pdf; // from backend
                            const byteCharacters = atob(base64); // decode base64 to binary string
                            const byteNumbers = new Array(byteCharacters.length);

                            for (let i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            const byteArray = new Uint8Array(byteNumbers);
                            const blob = new Blob([byteArray], { type: 'application/pdf' });

                            // create an object URL
                            const fileURL = URL.createObjectURL(blob);
                            window.open(fileURL, '_blank');
                        }),
                    );
                }),
            );

            return;
        }

        dispatch(
            getGeneratedReport(id, setReportLoading, (data) => {
                console.log('generated report==>', data);

                const base64 = data.pdf; // from backend
                const byteCharacters = atob(base64); // decode base64 to binary string
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });

                // create an object URL
                const fileURL = URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
            }),
        );
    };

    const [isModified, setIsModified] = useState(false);

    const onChangeMasterRule = ({ name, value }) => {
        let _rules = [...data.rules];
        _rules[0] = { ..._rules[0], ruleType: name, [name]: value };
        setData((prev) => ({ ...prev, rules: _rules }));
        setIsModified(true);
    };

    const itemTemplate = (item) => {
        return (
            <div className="text-sm">
                <div>{item.name}</div>
                <div className="text-secondary capitalize font-semibold">{snakeToCapitalized(item?.type)?.toLowerCase()}</div>
            </div>
        );
    };

    return (
        <>
            {addRuleDialog ? (
                <>
                    <RuleForm onCancel={handleCancel} onRuleSave={handleSaveRule} rule={selectedRule} />
                </>
            ) : (
                <FormPage backText="Reports">
                    <CustomCard col={12} title="Report Details">
                        <CustomGridLayout>
                            <CustomInput data={data} onChange={handleChange} name="title" />
                            <CustomTextArea data={data} onChange={handleChange} name="description" />
                        </CustomGridLayout>
                    </CustomCard>
                    <CustomCard col={12} title="Reports Rules">
                        <CustomGridLayout>
                            {data.rules.length > 0 ? (
                                <div className="col-12">
                                    <div className="flex justify-content-end gap-3 w-full">
                                        <PrimaryButton label="Add New Rule" onClick={handleAddRule} />
                                    </div>
                                    {data.rules.map((rule, index) => (
                                        <div
                                            className={`w-full flex justify-content-between gap-2 p-3 my-3 border-round-2xl shadow-2 ${index === 0 ? 'bg-lightest-blue' : 'bg-white'}`}
                                            key={index}
                                        >
                                            {index === 0 ? (
                                                <div className="w-full">
                                                    <div className="flex justify-content-between w-full">
                                                        <div className="font-bold text-lg mb-2 text-secondary capitalize">
                                                            Master Rule: {snakeToCapitalized(rule?.ruleType)?.toLowerCase()}
                                                        </div>
                                                        <i
                                                            onClick={() => {
                                                                setSelectedRule(rule);
                                                                setAddRuleDialog(true);
                                                            }}
                                                            className="pi pi-pencil my-auto text-xl cursor-pointer my-auto"
                                                        ></i>
                                                    </div>
                                                    <PurchasedServices info={rule[rule?.ruleType]} onChange={onChangeMasterRule} hideColumn />
                                                </div>
                                            ) : (
                                                <div className="flex justify-content-start">
                                                    <i className="pi pi-sort my-auto text-3xl"></i>
                                                    <div>
                                                        <div className="font-bold">{index ? `Rule ${index + 1}` : 'Master Rule'}</div>
                                                        <div className="text-secondary capitalize">{snakeToCapitalized(rule?.ruleType)?.toLowerCase()}</div>
                                                    </div>
                                                </div>
                                            )}

                                            {index > 0 && (
                                                <div className="flex gap-3">
                                                    <i
                                                        onClick={() => {
                                                            setSelectedRule(rule);
                                                            setAddRuleDialog(true);
                                                        }}
                                                        className="pi pi-pencil my-auto text-2xl cursor-pointer"
                                                    ></i>
                                                    <i className="pi pi-trash my-auto text-2xl cursor-pointer"></i>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="col-12 text-center py-5">
                                    <div>Create New Rules to start with the reports.</div> <PrimaryButton label="Create Master Rule" onClick={handleAddRule} />
                                </div>
                            )}
                        </CustomGridLayout>
                    </CustomCard>

                    {data.rules.length > 0 && (
                        <>
                            <CustomCard col={12} title="Total Column">
                                <CustomGridLayout>
                                    <CustomPickList
                                        name="totalColumns"
                                        showRuleIndex
                                        selected={data?.totalColumns}
                                        sourceData={allDataPoints.filter((item) => item.total)}
                                        onPickListChange={handleChange}
                                        itemTemplate={itemTemplate}
                                    />
                                </CustomGridLayout>
                            </CustomCard>
                            <CustomGridLayout>
                                <CustomCard col={8} title="Sort Column">
                                    <CustomGridLayout>
                                        <div className="col-12 py-2">
                                            {allDataPoints?.map((column, index) => (
                                                <>
                                                    <div
                                                        className="col-12 flex justify-content-between my-3 shadow-2 bg-white py-1 px-2 border-round-2xl cursor-pointer"
                                                        key={index}
                                                    >
                                                        <div className="col-3 flex gap-2">
                                                            <i className="pi pi-sort my-auto text-3xl"></i>
                                                            <div className="my-auto">
                                                                <div className="font-regular align-content-center">{column?.name}</div>

                                                                <div className="font-semibold text-sm">
                                                                    {column?.ruleIndex === 0 ? 'Master Rule' : `Rule ${column?.ruleIndex + 1}`}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* <CustomDropDown data={data} onChange={handleChange} name="column" options={allRuleColumns} /> */}
                                                        <CustomDropDown
                                                            col={4}
                                                            data={data}
                                                            onChange={handleChange}
                                                            name={'columnOrder'}
                                                            options={[
                                                                { name: 'Ascending', value: 'ASCENDING' },
                                                                { name: 'Descending', value: 'DESCENDING' },
                                                            ]}
                                                        />
                                                        <CustomDropDown
                                                            data={data}
                                                            col={4}
                                                            onChange={handleChange}
                                                            name={'breakType'}
                                                            options={[
                                                                { name: 'Page', value: 'PAGE' },
                                                                { name: 'Line', value: 'Line' },
                                                                { name: 'None', value: 'NONE' },
                                                            ]}
                                                        />
                                                    </div>
                                                </>
                                            ))}
                                        </div>
                                    </CustomGridLayout>
                                </CustomCard>{' '}
                                <CustomCard col={4} title="Display Options">
                                    <CustomGridLayout>
                                        <CustomDropDown
                                            data={data}
                                            onChange={handleChange}
                                            name="formatType"
                                            options={[
                                                { name: 'PDF', value: 'PDF' },
                                                { name: 'Excel', value: 'EXCEL' },
                                                { name: 'CSV', value: 'CSV' },
                                            ]}
                                            col={12}
                                        />
                                        <CustomDropDown data={data} onChange={handleChange} name="showPageHeaders" options={yesNoOptions} col={12} />
                                        <CustomDropDown data={data} onChange={handleChange} name="showPageFooters" options={yesNoOptions} col={12} />
                                        <CustomDropDown
                                            data={data}
                                            onChange={handleChange}
                                            name="pageOrientation"
                                            options={[
                                                { name: 'Landscape', value: 'LANDSCAPE' },
                                                { name: 'Portrait', value: 'PORTRAIT' },
                                            ]}
                                            col={12}
                                        />
                                    </CustomGridLayout>
                                    <div className="flex justify-content-end gap-3 w-full mt-3">
                                        <PrimaryButton
                                            label={isModified ? 'Save & Generate Report' : 'Generate Report'}
                                            onClick={generateReport}
                                            loading={reportLoading}
                                        />
                                        <PrimaryButton label="Save" onClick={handleSave} loading={loading} />
                                        <CustomButton label="Cancel" onClick={() => history.goBack()} />
                                    </div>
                                </CustomCard>
                            </CustomGridLayout>
                        </>
                    )}
                </FormPage>
            )}
        </>
    );
}
